export const LOADING_BATCH_PRODUCTION = "LOADING_BATCH_PRODUCTION";
export const GET_BATCH_PRODUCTION_LIST = "GET_BATCH_PRODUCTION_LIST";
export const ADD_BATCH_PRODUCTION = "ADD_BATCH_PRODUCTION";
export const UPDATE_BATCH_PRODUCTION = "UPDATE_BATCH_PRODUCTION";
export const REMOVE_BATCH_PRODUCTION = "REMOVE_BATCH_PRODUCTION";